import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import Check from '../../../../assets/svg/Feather/Check';
import ghAnalytics from '../../../../lib/analytics';

export default (dispatch) => ({
  clearImport() {
    dispatch({
      type: 'dataManager/clearImportFile'
    });
  },
  saveImport() {
    dispatch({
      type: 'dataManager/setIsImporting',
      payload: true
    });

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Importing file...',
        loader: true,
        dismissable: true
      }
    });

    ghAnalytics.logImportStarted();

    dispatch({
      type: 'dataManager/submitFile',
      callback: (uploadId, message) => {
        const defaultErrorMessage = 'There was an issue while importing your file'
        if (uploadId) {
          dispatch({
            type: 'dataManager/pollForImportDataEffect-start',
            payload: uploadId,
            callback: (featureCount, message) => {
              if (!featureCount) {
                dispatch({
                  type: 'toast/show',
                  payload: {
                    text: message || defaultErrorMessage,
                    icon: AlertCircle,
                    iconColor: '#FF3B30',
                    dismissable: true
                  }
                });
                dispatch({
                  type: 'dataManager/pollForImportDataEffect-stop'
                });
                dispatch({
                  type: 'dataManager/setIsImporting',
                  payload: false
                });
              } else {
                dispatch({
                  type: 'dataManager/pollForImportDataEffect-stop'
                });

                dispatch({
                  type: 'dataManager/setIsImporting',
                  payload: false
                });

                dispatch({
                  type: 'toast/show',
                  payload: {
                    text: 'Import successful',
                    icon: Check,
                    iconColor: '#F37735'
                  }
                });
                
                setTimeout(() => {
                  dispatch({
                    type: 'toast/dismiss'
                  });
                }, 3500);

                dispatch({
                  type: 'dataManager/clearImportFile'
                });

                ghAnalytics.logImportCompleted(featureCount);
              }
            }
          });
        } else {
          ghAnalytics.logImportFailed();
          dispatch({
            type: 'toast/show',
            payload: {
              text: message || defaultErrorMessage,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });

          dispatch({
            type: 'dataManager/setIsImporting',
            payload: false
          });
        }
      }
    });
  }
});